{
  "FILTER": {
    "TITLE": "Filtra conversazioni",
    "SUBTITLE": "Aggiungi i filtri qui sotto e clicca su “Applica filtri” per trovare subito le conversazioni che ti interessano.",
    "EDIT_CUSTOM_FILTER": "Modifica Cartella",
    "CUSTOM_VIEWS_SUBTITLE": "Aggiungi o rimuovi filtri e aggiorna la cartella.",
    "ADD_NEW_FILTER": "Aggiungi filtro",
    "FILTER_DELETE_ERROR": "Impossibile salvare: aggiungi almeno un filtro per continuare.",
    "SUBMIT_BUTTON_LABEL": "Applica filtri",
    "UPDATE_BUTTON_LABEL": "Aggiorna cartella",
    "CANCEL_BUTTON_LABEL": "Annulla",
    "CLEAR_BUTTON_LABEL": "Rimuovi filtri",
    "FOLDER_LABEL": "Nome Cartella",
    "FOLDER_QUERY_LABEL": "Query Cartella",
    "EMPTY_VALUE_ERROR": "Valore richiesto.",
    "TOOLTIP_LABEL": "Filtra conversazioni",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "E",
      "OR": "O"
    },
    "INPUT_PLACEHOLDER": "Inserisci valore",
    "CONTACT_SEARCH_PLACEHOLDER": "Cerca contatti",
    "CONTACT_FALLBACK": "Contatto #{id}",
    "OPERATOR_LABELS": {
      "equal_to": "Uguale a",
      "not_equal_to": "Non uguale a",
      "does_not_contain": "Non contiene",
      "is_present": "È presente",
      "is_not_present": "Non è presente",
      "is_greater_than": "È maggiore di",
      "is_less_than": "È minore di",
      "days_before": "È x giorni prima",
      "starts_with": "Inizia con",
      "equalTo": "Uguale a",
      "notEqualTo": "Non uguale a",
      "contains": "Contiene",
      "doesNotContain": "Non contiene",
      "isPresent": "È presente",
      "isNotPresent": "Non è presente",
      "isGreaterThan": "È maggiore di",
      "isLessThan": "È minore di",
      "daysBefore": "È x giorni prima",
      "startsWith": "Inizia con"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Vero",
      "FALSE": "Falso"
    },
    "ATTRIBUTES": {
      "STATUS": "Stato",
      "ASSIGNEE_NAME": "Nome assegnatario",
      "INBOX_NAME": "Nome Inbox",
      "TEAM_NAME": "Nome team",
      "CONTACT": "Contatto",
      "CONVERSATION_IDENTIFIER": "Identificativo conversazione",
      "CAMPAIGN_NAME": "Nome campagna",
      "LABELS": "Etichette",
      "BROWSER_LANGUAGE": "Lingua del browser",
      "PRIORITY": "Priorità",
      "COUNTRY_NAME": "Nome del Paese",
      "REFERER_LINK": "Link referente",
      "CUSTOM_ATTRIBUTE_LIST": "Elenco",
      "CUSTOM_ATTRIBUTE_TEXT": "Testo",
      "CUSTOM_ATTRIBUTE_NUMBER": "Numero",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Creato il",
      "LAST_ACTIVITY": "Ultima attività"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Valore richiesto",
      "ATTRIBUTE_KEY_REQUIRED": "Chiave attributo richiesta",
      "FILTER_OPERATOR_REQUIRED": "Operatore di filtro richiesto",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Il valore deve essere compreso tra 1 e 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtri standard",
      "ADDITIONAL_FILTERS": "Filtri aggiuntivi",
      "CUSTOM_ATTRIBUTES": "Attributi personalizzati"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Vuoi salvare questo filtro?",
        "LABEL": "Dai un nome a questo filtro",
        "PLACEHOLDER": "Dai un nome al filtro per poterlo richiamare in seguito.",
        "ERROR_MESSAGE": "Nome richiesto.",
        "SAVE_BUTTON": "Salva filtro",
        "CANCEL_BUTTON": "Annulla",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Cartella creata con successo.",
          "ERROR_MESSAGE": "Errore durante la creazione della cartella."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento creato con successo.",
          "ERROR_MESSAGE": "Errore durante la creazione del segmento."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Modifica cartella"
      },
      "DELETE": {
        "DELETE_BUTTON": "Elimina filtro",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Conferma eliminazione",
            "MESSAGE": "Sei sicuro di voler eliminare il filtro ",
            "YES": "Sì, elimina",
            "NO": "No, mantienilo"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Cartella eliminata con successo.",
          "ERROR_MESSAGE": "Errore durante l'eliminazione della cartella."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento eliminato con successo.",
          "ERROR_MESSAGE": "Errore durante l'eliminazione del segmento."
        }
      }
    }
  }
}
